import {
  getTinderAccounts,
  showTinderAccount,
  getPaidProxies,
  getPhoneProviders, 
  getTinderAccountGroups,
  getCountries,
  createTinderAccount,
  updateTinderAccount,
  deleteTinderAccount,
  authorizeTinderAccount
} from '../../api/tinderAccountsApi'
import { Message } from 'element-ui'

const state = {
  tinderAccounts: [],
  showTinderAccount: {},
  paidProxies: [],
  phoneProviders: [],
  tinderAccountGroups: [],
  countries: [],
  meta: {},
}

const getters = {
  getTinderAccounts: state => state.tinderAccounts,
  getTinderAccountsMeta: state => state.meta,
  showTinderAccount: state => state.showTinderAccount,
  getPaidProxies: state => state.paidProxies,
  getPhoneProviders: state => state.phoneProviders,
  getTinderAccountGroups: state => state.tinderAccountGroups,
  getCountries: state => state.countries,
}

const mutations = {
  SET_TINDER_ACCOUNTS: (state, payload) => {
    state.tinderAccounts = payload.data
    state.meta = payload.meta
  },
  SET_TINDER_ACCOUNT_SHOW: (state, payload) => {
    state.showTinderAccount = payload
  },
  SET_PAID_PROXIES: (state, payload) => {
    state.paidProxies = payload
  },
  SET_PHONE_PROVIDERS: (state, payload) => {
    state.phoneProviders = payload
  },
  SET_TINDER_ACCOUNT_GROUPS: (state, payload) => {
    state.tinderAccountGroups = payload
  },
  SET_TINDER_COUNTRY: (state, payload) => {
      state.countries = payload
  },
  DELETE_TINDER_ACCOUNT: (state, id) => {
    const index = state.tinderAccounts.findIndex(account => account.id === id)
    state.tinderAccounts.splice(index, 1)
  }
}

const actions = {
  getTinderAccounts: ({ commit }, params) => {
    getTinderAccounts(params)
      .then(resp => {
        commit('SET_TINDER_ACCOUNTS', resp)
      })
      .catch(err => console.log(err))
  },
  showTinderAccount: ({ commit, dispatch }, idUser) => {
    showTinderAccount(idUser)
      .then(r => {
        console.log(r)
        commit('SET_TINDER_ACCOUNT_SHOW', r.data)
      })
      .catch(err => {
        console.dir(err)
        if (err.response.status === 404) {
          console.log(router.push({ name: 'not-found' }))
        }
      })
  },
  clearCurrentTinderAccount: ({ commit }) => {
    commit('SET_TINDER_ACCOUNT_SHOW')
  },
  getTinderAccountGroups: ({ commit, dispatch }, idUser) => {
    getTinderAccountGroups()
      .then(r => {
        commit('SET_TINDER_ACCOUNT_GROUPS', r)
      })
      .catch(err => {
        console.dir(err)
        if (err.response.status === 404) {
          console.log(router.push({ name: 'not-found' }))
        }
      })
  },
  getCountries: ({ commit, dispatch }) => {
    getCountries()
      .then(r => {
        commit('SET_TINDER_COUNTRY', r)
      })
      .catch(err => {
        console.dir(err)
        if (err.response.status === 404) {
          console.log(router.push({ name: 'not-found' }))
        }
      })
  },
  getPaidProxies: ({ commit, dispatch }, idUser) => {
    getPaidProxies()
      .then(r => {
        commit('SET_PAID_PROXIES', r)
      })
      .catch(err => {
        console.dir(err)
        if (err.response.status === 404) {
          console.log(router.push({ name: 'not-found' }))
        }
      })
  },
  getPhoneProviders: ({ commit, dispatch }, idUser) => {
    getPhoneProviders()
      .then(r => {
        commit('SET_PHONE_PROVIDERS', r)
      })
      .catch(err => {
        console.dir(err)
        if (err.response.status === 404) {
          console.log(router.push({ name: 'not-found' }))
        }
      })
  },
  createTinderAccount: ({ commit }, payload) => new Promise((resolve, reject) => {
      createTinderAccount(payload)
        .then(resp => {
            return resolve(resp)
        })
        .catch(err => {
            return reject(err)
        })
  }),
  updateTinderAccount: ({ commit }, payload) => {
    updateTinderAccount(payload)
      .then(r => {
        Message({
          message: 'Data saved',
          type: 'success',
          duration: 5 * 1000
        })
      })
      .catch(err => console.dir(err))
  },
  deleteTinderAccount: ({ commit, dispatch }, id) => {
    deleteTinderAccount(id).then(r => {
      commit('DELETE_TINDER_ACCOUNT', id)

      Message({
        message: 'Tinder account has been deleted',
        type: 'success',
        duration: 5 * 1000,
        showClose: true
      })
    })
  },
  authorizeTinderAccount: ({ dispatch }, id) => new Promise((resolve, reject) => {
      authorizeTinderAccount(id)
      .then(response => {
          return resolve(response)
      })
      .catch(error => {
          return reject(error)
      })
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
